import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import DashboardOverview from "@/pages/DashboardOverview";
import LinksList from "@/pages/LinksList";
import NewLink from "@/pages/NewLink";
import LinkDetail from "@/pages/LinkDetail";
import LeadsPage from "@/pages/LeadsPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import AdminPaymentsPage from "@/pages/AdminPaymentsPage";
import AdminLandingVideosPage from "@/pages/AdminLandingVideosPage";
import AdminIntegrationsPage from "@/pages/AdminIntegrationsPage";
import ReferFriendPage from "@/pages/ReferFriendPage";
import EarningsPage from "@/pages/EarningsPage";
import PayoutHistoryPage from "@/pages/PayoutHistoryPage";
import PublicLink from "@/pages/PublicLink";
import SharePage from "@/pages/SharePage";
import SourceEarningsPage from "@/pages/SourceEarningsPage";
import SharesTimelinePage from "@/pages/SharesTimelinePage";

function AppRoutes() {
  const location = useLocation();
  // Synchronous OAuth callback detection — must happen during render, not effect
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/r/:slug" element={<PublicLink />} />
      <Route path="/share" element={<SharePage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardOverview /></ProtectedRoute>} />
      <Route path="/dashboard/links" element={<ProtectedRoute><LinksList /></ProtectedRoute>} />
      <Route path="/dashboard/links/new" element={<ProtectedRoute><NewLink /></ProtectedRoute>} />
      <Route path="/dashboard/links/:id" element={<ProtectedRoute><LinkDetail /></ProtectedRoute>} />
      <Route path="/dashboard/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
      <Route path="/dashboard/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/dashboard/refer" element={<ProtectedRoute><ReferFriendPage /></ProtectedRoute>} />
      <Route path="/dashboard/earnings" element={<ProtectedRoute><EarningsPage /></ProtectedRoute>} />
      <Route path="/dashboard/payouts" element={<ProtectedRoute><PayoutHistoryPage /></ProtectedRoute>} />
      <Route path="/dashboard/shares" element={<ProtectedRoute><SharesTimelinePage /></ProtectedRoute>} />
      <Route path="/dashboard/source/:source" element={<ProtectedRoute><SourceEarningsPage /></ProtectedRoute>} />
      <Route path="/dashboard/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="/dashboard/admin/payments" element={<ProtectedRoute><AdminPaymentsPage /></ProtectedRoute>} />
      <Route path="/dashboard/admin/landing-videos" element={<ProtectedRoute><AdminLandingVideosPage /></ProtectedRoute>} />
      <Route path="/dashboard/admin/integrations" element={<ProtectedRoute><AdminIntegrationsPage /></ProtectedRoute>} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
